import {ModalDialog} from "@/scripts/theme/modal-dialog";
import {qsaRequired, qsRequired, qsRequiredFromDocument} from '@/scripts/core/global'

export class KlaviyoOosPopup extends ModalDialog {
	static override htmlSelector = 'klaviyo-oos-popup'
	dynamicContentWrapper: HTMLElement
	constructor() {
		super()
		this.dynamicContentWrapper = qsRequired('[data-uc-klaviyo-oos-popup-content]', this)
		qsaRequired('[data-modal-close]',this).forEach(button => {
			button.addEventListener('click', this.hide.bind(this, false))
		})
	}

	override connectedCallback() {

	}

	async loadSectionContent(opener: HTMLButtonElement, productHandle: string, productVariantId: string) {
		const response = await fetch(`/products/${productHandle}?variant=${productVariantId}` + "&sections=klaviyo-oos-popup")
			.then(res => res.json())

		const html = new DOMParser().parseFromString(response['klaviyo-oos-popup'], 'text/html')
		const newContent = qsRequiredFromDocument('#DynamicContent', html)
		this.dynamicContentWrapper.innerHTML = newContent.innerHTML
		this.show(opener)
	}

	override show(opener?: HTMLButtonElement) {
		this.removeAttribute('style')
		window.setTimeout(() => {
			super.show(opener)
		}, 2)
		window.setTimeout(() => {
			void window.Ucoast.mediaManager.loadAllInContainer(this)
		}, 3)
	}

	override hide() {
		super.hide()
		this.style.display = 'none'
	}
}

